import React, { Component } from "react";
import * as s from "./FilterChipCollection.module.scss";
import { FilterChip } from "../FilterChip";
import { observer } from "mobx-react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  inputLabel: string;
  inputPlaceholder: {
    hasSelectedValues: string;
    noSelectedValues: string;
  };
  options: { value: string }[];
  onOptionClick: any;
  optionLimit?: number;
  separateOnKeyCodes?: { code: number }[];
}

interface State {
  hasBeenClicked: boolean;
}

@observer
export class FilterChipCollection extends Component<Props, State> {
  private inputRef;

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.state = { hasBeenClicked: false };
  }

  renderFilterChip = (item, key) => {
    const { options, onOptionClick } = this.props;
    const { value } = item;

    return (
      <FilterChip
        key={key}
        className={s.selectedLabel}
        title={value}
        small
        selected
        onClick={() => onOptionClick(options, item)}
      />
    );
  };

  focusInput = () => {
    this.inputRef.current.focus();
    this.setState({ hasBeenClicked: true });
  };

  createFilterChip = e => {
    const { options, onOptionClick, optionLimit, separateOnKeyCodes } = this.props;
    const inputField = this.inputRef && this.inputRef.current;
    let value = inputField && inputField.value;

    if (separateOnKeyCodes && separateOnKeyCodes.some(keyCode => keyCode.code === 32)) {
      value = value.replace(/[ ,]/g, "");
    } else {
      value = value.replace(/[,]/g, "");
    }

    const submitKeyPressed = separateOnKeyCodes
      ? separateOnKeyCodes.some(keyCode => keyCode.code === e.keyCode)
      : (e.keycode = 13);

    if (submitKeyPressed && value.length > 0) {
      if (!optionLimit) {
        onOptionClick(options, { value: value });
        inputField.value = "";
      } else if (options && options.length < optionLimit) {
        onOptionClick(options, { value: value });
        inputField.value = "";
      }
    }
  };

  addValueOnBlur = () => {
    const { options } = this.props;
    if (this.inputRef.current.value !== "") {
      this.props.onOptionClick(options, { value: this.inputRef.current.value });
      this.inputRef.current.value = "";
    }
  };

  render() {
    const { inputLabel, options, inputPlaceholder, className } = this.props;
    const { hasBeenClicked } = this.state;

    const filterChipCollectionContainerClasses = [s.filterChipCollectionContainer];
    const searchInputFieldLabelClasses = [s.searchInputFieldLabel];
    const searchInputFieldClasses = [s.searchInputField];
    const hasSelected = options && options.length !== 0;
    let inputPlaceholderText = "";

    if (className) filterChipCollectionContainerClasses.push(className);

    if (hasBeenClicked || hasSelected) {
      searchInputFieldLabelClasses.push(s.hasValueOrFocus);
      searchInputFieldClasses.push(s.hasValueOrFocus);
      inputPlaceholderText = hasSelected
        ? inputPlaceholder.hasSelectedValues
        : inputPlaceholder.noSelectedValues;
    } else {
      inputPlaceholderText = " ";
    }

    return (
      <div
        className={filterChipCollectionContainerClasses.join(" ")}
        onClick={this.focusInput}
      >
        <div className={s.selectedValuesContainer}>
          {options && options.map(this.renderFilterChip)}
        </div>
        <label htmlFor={inputLabel} className={searchInputFieldLabelClasses.join(" ")}>
          {inputLabel}
        </label>
        <input
          type="text"
          className={searchInputFieldClasses.join(" ")}
          id={inputLabel}
          placeholder={inputPlaceholderText}
          onKeyUp={this.createFilterChip}
          onFocus={() => this.setState({ hasBeenClicked: true })}
          onBlur={this.addValueOnBlur}
          ref={this.inputRef}
        />
      </div>
    );
  }
}
